import { render } from "./SelectInitialCards.vue?vue&type=template&id=eb414386&ts=true"
import script from "./SelectInitialCards.vue?vue&type=script&lang=ts"
export * from "./SelectInitialCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__